// ============================================================
// MedicalAgencySection.tsx
// Stage 3 redesign (approved mockup casevo-case-sections-batch2.html):
// the shared "party contact" card section — see
// components/case/sections/PartyContactSection.tsx. Fields, fieldKeys,
// address-lookup broadcast, the Yjs notes doc `case:<id>:medicalAgencyNotes`
// and mark-complete ('medicalAgency') are exactly as the old long form.
// ============================================================
import React from 'react'
import PartyContactSection, { type PartyConfig } from '../case/sections/PartyContactSection'

const CONFIG: PartyConfig = {
  prefix: 'medicalAgency',
  sectionKey: 'medicalAgency',
  title: 'Medical agency',
  sub: 'The agency arranging the medical evidence.',
  cardTitle: 'Medical agency',
  icon: 'agency',
  nameLabel: 'Agency name',
  nameKey: 'medicalAgency.agency-name',
  who: 'the agency',
  notesPlaceholder: 'Notes about the medical agency…',
  readySub: 'No required fields: complete it once the agency is instructed.',
}

const MedicalAgencySection: React.FC = () => <PartyContactSection config={CONFIG} />
export default MedicalAgencySection
